import PersonCard from 'containers/partials/cards/PersonCard';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import { ROUTE_PERSONS_ENTITY_PERSON_GLOBAL } from 'routes/RouteList';
import IntegrationsCard from 'containers/pages/persons/components/IntegrationsCard';
import Loader from 'components/loader/Loader';

const PersonGlobalTab = () => {
  const { entityId, groupId, personId } = useParams();
  const { push } = useHistory();
  const person = useEntityContext(s => s.person);

  const onCancel = () => {
    push(
      generatePath(ROUTE_PERSONS_ENTITY_PERSON_GLOBAL, {
        entityId,
        groupId,
        personId
      })
    );
  };

  return (
    <>
      {!person && <Loader />}
      <PersonCard entityId={entityId} person={person} onCancel={onCancel} />
      {Object.keys(person.integrations).length > 0 && (
        <IntegrationsCard person={person} />
      )}
    </>
  );
};

export default PersonGlobalTab;
